var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-snoweb svg-theme-light",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 100 100",
    width: 100,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    y: 0,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M59.7,47,48.3,39.4a3.6,3.6,0,0,0-5.6,3V57.6a3.6,3.6,0,0,0,5.6,3L59.7,53A3.6,3.6,0,0,0,59.7,47Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M82.1,50A32.1,32.1,0,1,1,50,17.9,32.1,32.1,0,0,1,82.1,50Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_play.f5cc7a5a9efe7ce2b172d1dca249f64c.svg";